// extracted by mini-css-extract-plugin
export default {"Introduction":"Introduction_Introduction__2Yt2Q","slide-in":"Introduction_slide-in__N8h8t","Heading":"Introduction_Heading__Q6055","Description":"Introduction_Description__LDB5w"};